export default __webpack_public_path__ + "static/media/13D.3485eeb4.webp";